export const schema = () => ({
  schema: {
    document: {
      nodes: [
        {
          match: { object: "block" },
          min: 1
        }
      ],
      normalize: (editor, { code, node }) => {
        switch (code) {
          case "child_min_invalid":
            editor.insertNodeByKey(node.key, node.nodes.size, {
              type: "paragraph",
              object: "block"
            })
            return
          default:
            return
        }
      }
    }
  }
})
